import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import '@google/model-viewer';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
    const megaheroBlocks = document.querySelectorAll(".block-megahero");

    if (!megaheroBlocks.length) return;

    megaheroBlocks.forEach(el => {
        const blockTitle = el.querySelector(".block-title.glossy");
        const blockSubtitle = el.querySelector(".megahero-footer .block-subtitle");
        const blockArrow = el.querySelector(".megahero-footer svg");
        const megaheroModels = el.querySelector(".megahero-models");

        gsap.set([megaheroModels, blockSubtitle, blockArrow], { y: -50, opacity: 0 });

        if (blockTitle) {
            gsap.fromTo(blockTitle,
                { backgroundPosition: "200% 0%" },
                {
                    backgroundPosition: "0% 0%",
                    duration: 2,
                    ease: "power2.out",
                    onComplete: () => {
                        gsap.fromTo(megaheroModels,
                            { y: -50, opacity: 0 },
                            {
                                y: 0,
                                opacity: 1,
                                duration: 0.5,
                                ease: "power2.out",
                                delay: 0.25,
                                onComplete: () => {
                                    gsap.fromTo(blockSubtitle,
                                        { y: -50, opacity: 0 },
                                        {
                                            y: 0,
                                            opacity: 1,
                                            duration: 0.5,
                                            ease: "power2.out",
                                            delay: 0.25,
                                            onComplete: () => {
                                                gsap.fromTo(blockArrow,
                                                    { y: -50, opacity: 0 },
                                                    {
                                                        y: 0,
                                                        opacity: 1,
                                                        duration: 0.5,
                                                        ease: "power2.out",
                                                        delay: 0.125
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }
                            }
                        );
                    }
                }
            );
        }

        const viewerA = document.getElementById("megahero-viewer");
        const viewerB = document.getElementById("megahero-viewer-shadow");
        const betterUX = document.getElementById("betterUX");

        const modelPaths = viewerA.dataset.modelPaths.split(',').map(path => path.trim());

        let index = 0;
        let intervalId = null;
        let activeTrigger = null;
        let currentViewer = viewerA;
        let nextViewer = viewerB;
        let isUserInteracting = false;

        function crossFadeModels(newSrc) {
            if (activeTrigger) activeTrigger.kill();
            if (isUserInteracting) return;

            nextViewer.setAttribute("src", newSrc);
            gsap.set(nextViewer, {
                opacity: 0,
                filter: "blur(8px)",
                scale: 0.95,
                zIndex: 4,
                pointerEvents: "none"
            });

            gsap.to(currentViewer, {
                opacity: 0,
                duration: 0.3,
                ease: "power2.out",
                onComplete: () => {
                    gsap.set(currentViewer, { zIndex: 0, pointerEvents: "none" });
                }
            });

            nextViewer.addEventListener("load", function handleLoad() {
                nextViewer.removeEventListener("load", handleLoad);

                gsap.to(nextViewer, {
                    opacity: 1,
                    filter: "blur(0px)",
                    scale: 1,
                    duration: 1,
                    ease: "power3.out",
                    onStart: () => {
                        nextViewer.style.pointerEvents = "auto";
                        gsap.set(nextViewer, { zIndex: 3 });
                    },
                    onComplete: () => {
                        const temp = currentViewer;
                        currentViewer = nextViewer;
                        nextViewer = temp;

                        currentViewer.setAttribute("camera-controls", "true");
                        currentViewer.removeAttribute("interaction-prompt");

                        activeTrigger = ScrollTrigger.create({
                            trigger: betterUX,
                            start: "top bottom",
                            end: "bottom+=50% top",
                            scrub: 1,
                            onUpdate: self => {
                                const progress = self.progress;
                                const scrollDistance = window.innerHeight + betterUX.offsetHeight;
                                const yOffset = progress * scrollDistance;
                                const newOpacity = progress < 0.5 ? 1 : 1 - (progress - 0.5) * 2;
                                const zIndex = progress >= 0.95 ? -1 : 1;

                                gsap.set(currentViewer, {
                                    y: yOffset,
                                    opacity: newOpacity,
                                    zIndex: zIndex
                                });
                            }
                        });
                    }
                });
            });
        }

        function startLoop() {
            if (intervalId) clearInterval(intervalId);
            intervalId = setInterval(() => {
                index = (index + 1) % modelPaths.length;
                crossFadeModels(modelPaths[index]);
            }, 5000);
        }

        function stopLoop() {
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        }

        gsap.set(viewerA, { opacity: 1, zIndex: 3 });
        gsap.set(viewerB, { opacity: 0, zIndex: 0 });
        startLoop();

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
                stopLoop();
            } else if (document.visibilityState === "visible") {
                if (activeTrigger) activeTrigger.kill();
                gsap.set(currentViewer, { opacity: 0, y: 0, zIndex: 3 });
                gsap.set(nextViewer, { opacity: 0, y: 0, zIndex: 0 });
                crossFadeModels(modelPaths[index]);
                startLoop();
            }
        });

        [currentViewer, nextViewer].forEach(viewer => {
            viewer.addEventListener("contextmenu", e => e.preventDefault());
            viewer.addEventListener("mousedown", e => {
                if (e.button === 0) isUserInteracting = true;
            });
            viewer.addEventListener("mouseup", () => {
                isUserInteracting = false;
            });
        });
    });
});
